@if (sources().length > 0 && !hideMenuTriggerButton()) {
  <button
    mat-icon-button
    [matMenuTriggerFor]="dxcSourceMenu"
    matTooltip="Data XChange"
  >
    <mat-icon>sync_alt</mat-icon>
  </button>
}
<mat-menu #dxcSourceMenu="matMenu">
  @for (source of sources(); track source) {
    <button mat-menu-item (click)="onClickDxcSource(source)">
      {{ source.name }}
    </button>
  }
</mat-menu>
